
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { company } from '@components/config/company/Details';
import { DefaultSeo, NextSeo } from 'next-seo';
import { NEXT_SEO_DEFAULT } from '../next-seo.config';

import { JsonLdOrg } from '@components/config/strucureData/OrganisationJsonLd';
import { JsonLdFaq } from '@components/config/strucureData/FaqJsonLd';
import { JsonLdReview } from '@components/config/strucureData/ReviewsJsonLd';
import About from '@pages/about';

export default function Index() {
  return (
    <>
      <NextSeo
        title={`Reliable & Convenient Private Hire Service | ${company.name}`}
        description="Need safe and reliable transportation? Look no further than Shipley Central Private Hire Taxis. We serve a wide range of areas, including Leeds Bradford Airport and Manchester Airport. Our fleet of new vehicles includes saloons, estate MPVs, and minibuses that can accommodate up to 8 passengers and wheelchairs."
        openGraph={{
          url: `${company.url}/about-us`,
        }}
        canonical={`${company.url}/about-us`}
      />
      <JsonLdOrg />
      <JsonLdReview />
      <div>
        <About />
      </div>
    </>
  );
}
